// Header Scripts

function headerFunctions(jQuery) {
  
$('body').click(function(evt){  
       if(evt.target.id == "header_search") {
          return;
       }
       //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
       if($(evt.target).closest('#header_search').length) {
          return;             
       }

       if(evt.target.id == "side_search") {
          return;
       }
       //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
       if($(evt.target).closest('#side_search').length) {
          return;             
       }

      //Do processing of click event here for every element except with id menu_content
      $(".side_search").hide();

});



  if ($(document).scrollTop() >= 12) {
    $(".main_header").css("background", "#fff");
    $(".mega_shop").hide();
    $(".mega_best_sellers").hide();
    $(".mega_about").hide();
    $(".mega_quiz").hide();
    $("#header_search img").click(function(){
      $(".template-index .main_header").fadeIn().css("background", "#fff");
    });
    $("#header_cart a").click(function(){
      $(".template-index .main_header").css("background", "#fff");
    });
  //} else {
  //  $(".template-index .main_header").fadeIn().css("background", "transparent");
  }

$(document).scroll(function() {
  if ($(document).scrollTop() >= 12) {
    $(".main_header").fadeIn().css("background", "#fff");
    $(".mega_shop").hide();
    $(".mega_best_sellers").hide();
    $(".mega_about").hide();
    $(".mega_quiz").hide();
  //} else {
  //  $(".template-index .main_header").fadeIn().css("background", "transparent");
  }
});
  
  $("#header_accounts").click(function(){
    $(".sign_in_box").toggle();
  });
  $(document).click(function(e) {
      if (!$(e.target).is('.sign_in_box, .sign_in_box *, #header_accounts, #header_accounts *')) {
        $(".sign_in_box").hide();
      }
  });

Shopify.onItemAdded = function(cart) {
  jQuery.getJSON('/cart.js', function(cart) {
      $('#cart_counter').html(cart.item_count);
  });
};

    $('#hamburger').click(function(){
      $(this).toggleClass('open');
      $(".mobile_menu").fadeToggle();
      $("#header_bar").fadeIn(10000).toggleClass("active_menu");
      $("html").toggleClass("prevent_x_scroll");
      $(".main_header").toggleClass("white_bg");
      $("body").toggleClass('ham_open');
      $("#cover_page_nav").fadeToggle();
    });

    $("#cover_page_nav").click(function() {
      $("#cover_page_nav").hide();
      $("html").removeClass("prevent_x_scroll");
      $(".main_header").removeClass("white_bg");
    });

    $('#header_search img').click(function(){
      $("#hamburger").removeClass('open');
      $(".mobile_menu").fadeOut();
      $("#header_bar").addClass("active_menu");
      $(".main_header").removeClass("white_bg");
      $("body").removeClass('ham_open');
    });


    $('#header_cart img').click(function(){
      $("#hamburger").removeClass('open');
      $(".mobile_menu").fadeOut();
      $("#header_bar").addClass("active_menu");
      $(".main_header").removeClass("white_bg");
      $("body").removeClass('ham_open');
    });



      $("ul#tabs-titles li:first-child").addClass("current");


  $("li#main_nav_shop").mouseover(function(){
    $(this).toggleClass("green_underline");
    $("#main_nav_best").removeClass("green_underline");
    $("#main_nav_about").removeClass("green_underline");
    $("#main_nav_quiz").removeClass("green_underline");
    $(".mega_shop").toggle();
    $(".mega_best_sellers").hide();
    $(".mega_about").hide();
    $(".mega_quiz").hide();
    $("#header_bar").toggleClass("active_menu").removeClass("active_menu2").removeClass("active_menu3");
    $(".main_header").css("background", "#fff");
  });

  $("li#main_nav_best").mouseover(function(){
    $(this).toggleClass("green_underline");
    $("#main_nav_shop").removeClass("green_underline");
    $("#main_nav_about").removeClass("green_underline");
    $("#main_nav_quiz").removeClass("green_underline");
    $(".mega_shop").hide();
    $(".mega_best_sellers").toggle();
    $(".mega_about").hide();
    $(".mega_quiz").hide();
    $("#header_bar").removeClass("active_menu").toggleClass("active_menu2").removeClass("active_menu3");
    $(".main_header").css("background", "#fff");

  });

  $("li#main_nav_about").mouseover(function(){
    $(this).toggleClass("green_underline");
    $("#main_nav_shop").removeClass("green_underline");
    $("#main_nav_best").removeClass("green_underline");
    $(".mega_shop").hide();
    $(".mega_best_sellers").hide();
    $(".mega_about").toggle();
    $(".mega_quiz").hide();
    $("#header_bar").removeClass("active_menu").removeClass("active_menu2").toggleClass("active_menu3");
    $(".main_header").css("background", "#fff");
  });

  $("li#main_nav_quiz").mouseover(function(){
    $(this).toggleClass("green_underline");
    $("#main_nav_shop").removeClass("green_underline");
    $("#main_nav_best").removeClass("green_underline");
    $(".mega_shop").hide();
    $(".mega_best_sellers").hide();
    $(".mega_about").hide();
    $(".mega_quiz").toggle();
    $("#header_bar").removeClass("active_menu").removeClass("active_menu2").toggleClass("active_menu3");
    $(".main_header").css("background", "#fff");
  });

  $(document).mouseover(function(e) {
      if (!$(e.target).is('#shopify-section-header, #shopify-section-header *')) {
        $("#main_nav_shop").removeClass("green_underline");
        $("#main_nav_best").removeClass("green_underline");
        $("#main_nav_about").removeClass("green_underline");
        $("#main_nav_quiz").removeClass("green_underline");
        $(".mega_shop").hide();
        $(".mega_best_sellers").hide();
        $(".mega_about").hide();
        $(".mega_quiz").hide();
        $("#header_bar").removeClass("active_menu").removeClass("active_menu2").removeClass("active_menu3");
      }
  });


  var topBarHeight = $(".top_bar").innerHeight();
  var headerHeight = $(".main_header").innerHeight();
  var totalHeadHeight = topBarHeight + headerHeight;
  $("#header_bar").css("margin-top", topBarHeight);
  $(".main").css("padding-top", totalHeadHeight);
  $(".template-index .main").css("padding-top", topBarHeight)
  $(".template-blog .main").css("padding-top", topBarHeight)
  $(".template-article .main").css("padding-top", topBarHeight)
  $("#our-story .main").css("padding-top", topBarHeight);
  $(".mobile_menu").css({"margin-top": topBarHeight, "padding-top": headerHeight});


$(window).resize(function() {
  var topBarHeight = $(".top_bar").innerHeight();
  var headerHeight = $(".main_header").innerHeight();
  var totalHeadHeight = topBarHeight + headerHeight;
  $("#header_bar").css("margin-top", topBarHeight);
  $(".main").css("padding-top", totalHeadHeight);
  $(".template-index .main").css("padding-top", topBarHeight)
  $(".template-blog .main").css("padding-top", topBarHeight)
  $(".template-article .main").css("padding-top", topBarHeight)
  $("#our-story .main").css("padding-top", topBarHeight);
  $(".mobile_menu").css({"margin-top": topBarHeight, "padding-top": headerHeight});
});

 $(window).resize(function() {
  if ($(window).width() >= 929) {
    $(".main_header").removeClass("white_bg");
    $("html").removeClass("prevent_x_scroll");
    if ($(".mobile_menu").is(":visible")) {
       $(".mobile_menu").hide();
       $("#hamburger").removeClass('open');
       $(".header_bar").removeClass("active_menu");
    }
  }
  if ($(window).width() <= 929) {
    $("#main_nav_shop").removeClass("green_underline");
    $("#main_nav_best").removeClass("green_underline");
    $("#main_nav_about").removeClass("green_underline");
    $("#main_nav_quiz").removeClass("green_underline");
    $(".mega_shop").hide();
    $(".mega_best_sellers").hide();
    $(".mega_about").hide();
    $(".mega_quiz").hide();
  }
});

  var tabs = $('#tabs-titles li'); //grab tabs
  var contents = $('#tabs-contents li'); //grab contents

  tabs.bind('mouseover', function () {
      contents.hide(); //hide all contents
      tabs.removeClass('current'); //remove 'current' classes
      $(contents[$(this).index()]).show(); //show tab content that matches tab title index
      $(this).addClass('current'); //add current class on clicked tab title
  });
}

// Footer Scripts

function footerFunctions(jQuery) {

function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  var acc = document.getElementsByClassName("footer_accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active_footer");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

// Product Page Scripts

function productFunctions(jQuery) {

  var currencyCharacter = $(".currency_code").val().charAt(0);
  $(".discount_bubble span.selected_currency").html(currencyCharacter);

  $(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 800) {
      $('.rmz-chat-bubble').addClass('change_chat_pos');
      $(".smile-launcher-frame").hide();
      $("#reamazejs-container").hide();
    } else {
      $('.rmz-chat-bubble').removeClass('change_chat_pos');
      $(".smile-launcher-frame").show();
      $("#reamazejs-container").show();
    }
    var docHeight = $(document).height();
    var hidePos = docHeight - 500;
     if($(window).scrollTop() + $(window).height() > hidePos || y < 800) {
         $('.atc_sticky').fadeOut();
     } else if ($(window).scrollTop() + $(window).height() < hidePos && y > 800) {
       $('.atc_sticky').fadeIn();
     }
  });

    // Example 1
    $("#header_bar.sticky_gallery").stickOnScroll({
        topOffset: 0,
        setParentOnStick:   true,
        setWidthOnStick:    false
    });
  
    $("#product_upper_left.sticky_gallery")
      .stickOnScroll({
          topOffset:          $("#header_bar").outerHeight(),
          bottomOffset:       0,
          footerElement:      $("#product_lower"),
          setParentOnStick:   true,
          setWidthOnStick:    true
    });

    $(window).resize(function() {
      var testing = $(".testing").width();
      var topBarHeight = $(".top_bar").outerHeight();
      $("#product_upper_left.sticky_gallery").css({"width" : testing, "position" : "static"});
    });

    $(".shopify-section.featured_products").appendTo(".faq_section_append");
    $(".section.comparesec").parent(".shopify-section").appendTo(".compare_section_append");

}

// Blog

function blogFunctions(jQuery) {

    $( "span#topic_dropdown_button" ).click(function() {
      $(".blog_sort_buttons").toggle();
      $(this).toggleClass("button_arrow_down");
    });

    $(document).click(function(e) {
        if (!$(e.target).is('.blog_sort_buttons, .blog_sort_buttons *, #topic_dropdown_button, #topic_dropdown_button *') && $(window).width() < 650 ) {
          $(".blog_sort_buttons").hide();
        }
    });

    if (window.location.href.indexOf("makeup") > -1) {
       $('span#topic_dropdown_button').text('makeup');
       $("#topic_button_makeup").css("background", "#eee");
    } else if (window.location.href.indexOf("skincare") > -1) {
       $('span#topic_dropdown_button').text('skincare');
       $("#topic_button_skincare").css("background", "#eee");
    } else {
       $('span#topic_dropdown_button').text('all topics');
       $("#topic_button_all").css("background", "#eee");
    }

    if ($(window).width() > 650) {
        $("#topic_button_all").show();
        $("#topic_button_makeup").show();
        $("#topic_button_skincare").show();
    }


    $(window).resize(function() {
      if (window.location.href.indexOf("makeup") > -1 && $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('makeup');
         $("#topic_button_makeup");
      } else if (window.location.href.indexOf("skincare") > -1 && $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('skincare');
         $("#topic_button_skincare");
      } else if ( $(window).width() < 650 ) {
         $('span#topic_dropdown_button').text('all topics');
         $("#topic_button_all");
      }

      if ($(window).width() > 649) {
          $(".blog_sort_buttons").show();
          $("#topic_button_all").css("display", "inline-block");
          $("#topic_button_makeup").css("display", "inline-block");
          $("#topic_button_skincare").css("display", "inline-block");
          $("span#topic_dropdown_button").removeClass("button_arrow_down");
      } else if ($(window).width() < 650) {
          $(".blog_sort_buttons").hide();
          $("#topic_button_all").css("display", "block");
          $("#topic_button_makeup").css("display", "block");
          $("#topic_button_skincare").css("display", "block");
      }

    });

}

///// SECTIONS /////

// My Cart 

function myCartFunctions(jQuery) {
  
  $(document).ready(function() {
    var windowWidth = $(window).width();
    if ($(window).width() < 360) {
       $(".my-cart").css("width", windowWidth);
    }
  });
  $(window).resize(function() {
    var windowWidth = $(window).width();
    if ($(window).width() < 360) {
       $(".my-cart").css("width", windowWidth);
    }
  });
  $( "#header_cart" ).click(function() {
    $("#smile-ui-lite-container").hide();
    $("#reamazejs-container").hide();
    var startTime = new Date().getTime(); // Get the current time
    
    var interval = setInterval(function() {
      var currentTime = new Date().getTime(); // Get the current time again
      
      var elapsedTime = currentTime - startTime; // Calculate the elapsed time
      
      if (elapsedTime >= 1600) { // Stop the interval after 3 seconds
        clearInterval(interval);
      }
      
        var cartBottomHeight = $(".cart_bottom").outerHeight();
        $(".my-cart__items").css("height", "calc(100% - " + cartBottomHeight + "px");
      
    }, 200); // Run the function every 0.2 seconds (200 milliseconds)
  });
  $(".cart_close").click(function() {
    $("#smile-ui-lite-container").show();
    $("#reamazejs-container").show();
  });
  $("#cover_page").click(function() {
    $("#smile-ui-lite-container").show();
    $("#reamazejs-container").show();
    $(this).hide();
  });
}